import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Switch } from "../ui/switch";
import { Textarea } from "../ui/textarea";
import { Field } from "../Field";
import { Segmented, YES_NO, TRANSPORT } from "../Segmented";
import { TextField } from "./StepCustomer";
import { useConfig } from "../../context/BrandContext";

const VehicleFields = ({ it, set, errors }) => (
  <>
    <TextField id="item.year" label="Year *" value={it.year} onChange={(v) => set("item", "year")(v.replace(/\D/g, "").slice(0, 4))} error={errors["item.year"]} inputProps={{ inputMode: "numeric", placeholder: "2021" }} />
    <TextField id="item.make" label="Make *" value={it.make} onChange={set("item", "make")} error={errors["item.make"]} inputProps={{ placeholder: "Toyota" }} />
    <TextField id="item.model" label="Model *" value={it.model} onChange={set("item", "model")} error={errors["item.model"]} inputProps={{ placeholder: "Camry" }} />
    <TextField id="item.vin" label="VIN (optional)" value={it.vin} onChange={(v) => set("item", "vin")(v.toUpperCase().slice(0, 17))} error={errors["item.vin"]} inputProps={{ className: "field-input font-mono" }} />
    <Field id="item.operable" label="Operable?"><Segmented value={it.operable} onChange={set("item", "operable")} options={YES_NO} testid="reg-operable" /></Field>
  </>
);

const FreightFields = ({ it, set, errors }) => (
  <>
    <Field id="item.description" label="Freight description *" error={errors["item.description"]} className="sm:col-span-2">
      <Textarea id="item.description" rows={3} value={it.description} onChange={(e) => set("item", "description")(e.target.value)} placeholder="e.g. 2 pallets of farm equipment parts"
        className={`rounded-none bg-white border-slate-300 focus-visible:ring-amber-500 ${errors["item.description"] ? "border-red-500" : ""}`} data-testid="reg-input-item-description" />
    </Field>
    <TextField id="item.weight_lbs" label="Approx. weight (lbs)" value={it.weight_lbs} onChange={(v) => set("item", "weight_lbs")(v.replace(/[^\d.]/g, ""))} error={errors["item.weight_lbs"]} inputProps={{ inputMode: "decimal" }} />
    <TextField id="item.dimensions" label="Dimensions (L × W × H)" value={it.dimensions} onChange={set("item", "dimensions")} inputProps={{ placeholder: "48 × 40 × 60 in" }} />
  </>
);

export const StepItem = ({ form, set, errors }) => {
  const { item_types } = useConfig();
  const it = form.item;
  return (
    <div className="grid sm:grid-cols-2 gap-5" data-testid="reg-step-item">
      <Field id="item.item_type" label="Type *">
        <Select value={it.item_type} onValueChange={set("item", "item_type")}>
          <SelectTrigger className="field-input" data-testid="reg-select-item-type"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white border-slate-300 text-slate-900 rounded-none">
            {item_types.map((t) => <SelectItem key={t.value} value={t.value} data-testid={`reg-item-option-${t.value}`}>{t.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </Field>
      <Field id="item.transport_type" label="Carrier"><Segmented value={it.transport_type} onChange={set("item", "transport_type")} options={TRANSPORT} testid="reg-transport" /></Field>
      {it.item_type === "freight" ? <FreightFields it={it} set={set} errors={errors} /> : <VehicleFields it={it} set={set} errors={errors} />}
      <label htmlFor="reg-expedited" className="sm:col-span-2 flex items-center justify-between gap-3 px-4 py-3 border border-slate-200 bg-white cursor-pointer">
        <span>
          <span className="font-display uppercase tracking-wider font-semibold text-slate-900">Expedited service</span>
          <span className="block text-xs text-slate-500">Priority dispatch and a tighter delivery window</span>
        </span>
        <Switch id="reg-expedited" checked={it.expedited} onCheckedChange={set("item", "expedited")} data-testid="reg-switch-expedited" className="data-[state=checked]:bg-amber-500" />
      </label>
    </div>
  );
};
